export const getHeaders = (): string[] => {
  return ['As of', 'Company name', 'Ticker', 'Enterprise value', 'Revenue (TTM)', 'EV/Revenue', 'Description'];
};

export const getHeadersForCurrentCompany = (): string[] => {
  return ['As of', 'Company name', 'Annual revenue', 'Average market ratio', 'Discount rate', 'Company value', 'PPS'];
};
